import { fg } from '@atlassian/jira-feature-gating';

export default {
	get(): boolean {
		return fg('icc_harmonisation_backlog_v1');
	},
};
